import { useMemo, useState } from 'react';
import Card from "../../../../componentes/contenedores/Card";
import CardTab from "../../../../componentes/contenedores/CardTab";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import TablaPagosCompras from './TablaPagosCompras';
import TablaPagosVentas from './TablasPagosVentas';
import { formatoFecha } from '../../../../configuracion/validaciones';
import moment from 'moment';

const HomePagos = () => {
    const { listaPagosVentas, listaPagosCompras } = useContextEmpleado();
    const [documentoFiltro, setDocumentoFiltro] = useState("FA");
    const [documentoFiltroTemp, setDocumentoFiltroTemp] = useState("FA");
    const [fechaFiltro, setFechaFiltro] = useState(formatoFecha(new Date()));
    const [fechaFiltroTemp, setFechaFiltroTemp] = useState(formatoFecha(new Date()));

    const [panelAbierto, setPanelAbierto] = useState(false);

    const datos = {
        titulo: {
            titulo: "Busqueda de pagos",
            url: "/app/admin/cajeros/buscarpagos",
            tituloUrl: "Menú Pagos",
            nombreUrl: "Inicio",
        },
    };

    const pagosVentasFiltrados = useMemo(() => {
        let pagos = listaPagosVentas;
        console.log("Pagos de ventas antes de filtrar:", pagos);
        if (documentoFiltro !== "TODOS") {
            pagos = pagos.filter(p => p.documento === documentoFiltro);
        }

        if (fechaFiltro) {
            const fechaDeseada = fechaFiltro;

            pagos = pagos.filter(p => {
                const fechaPagoFormateada = p.fecha ? formatoFecha(p.fecha) : null;
                return fechaPagoFormateada === fechaDeseada;
            });
        }

        return pagos;
    }, [listaPagosVentas, documentoFiltro, fechaFiltro]);

    const pagosComprasFiltrados = useMemo(() => {
        let pagos = listaPagosCompras;

        if (documentoFiltro !== "TODOS") {
            pagos = pagos.filter(p => p.documento === documentoFiltro);
        }

        if (fechaFiltro) {
            const fechaDeseada = fechaFiltro;

            pagos = pagos.filter(p => {
                const fechaPagoFormateada = p.fecha ? formatoFecha(p.fecha) : null;
                return fechaPagoFormateada === fechaDeseada;
            });
        }

        return pagos;
    }, [listaPagosCompras, documentoFiltro, fechaFiltro]);

    const pagosEfectivoC = useMemo(
        () => pagosComprasFiltrados.filter(p => p.pagoefectivos?.length > 0),
        [pagosComprasFiltrados]
    );

    const pagosTarjetaC = useMemo(
        () => pagosComprasFiltrados.filter(p => p.pagotarjeta?.length > 0),
        [pagosComprasFiltrados]
    );

    const pagosTransferenciaC = useMemo(
        () => pagosComprasFiltrados.filter(p => p.pagotransferencia?.length > 0),
        [pagosComprasFiltrados]
    );

    const handleFiltrar = () => {
        setDocumentoFiltro(documentoFiltroTemp);
        setFechaFiltro(fechaFiltroTemp);

        const fechaInicio = fechaFiltroTemp;
        if (fechaInicio) {
            const valorFecha = moment(fechaInicio).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        }

        setPanelAbierto(false);
    };

    const handleReset = () => {
        setDocumentoFiltro("FA");
        setDocumentoFiltroTemp("FA");
        setFechaFiltro(moment().format("YYYY-MM-DD"));
        setFechaFiltroTemp(moment().format("YYYY-MM-DD"));
        setPanelAbierto(false);
    };

    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-end">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "240px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        <div className="form-group mb-3">
                            <label htmlFor="documentoFiltroSelect" className="form-label fw-bold">Documento</label>
                            <select
                                id="documentoFiltroSelect"
                                className="form-control form-control-sm"
                                value={documentoFiltroTemp}
                                onChange={(e) => setDocumentoFiltroTemp(e.target.value)}
                            >
                                <option value="FA">Facturas</option>
                                <option value="RE">Recibos</option>
                                <option value="CR">Créditos</option>
                                <option value="TODOS">Todos</option>
                            </select>
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="fechaFiltroInput" className="form-label fw-bold">Fecha</label>
                            <input
                                id="fechaFiltroInput"
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFiltroTemp}
                                onChange={(e) => setFechaFiltroTemp(e.target.value)}
                            />
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );


    return (
        <Page datos={datos}>
            <CardTab
                tabs={[
                    {
                        title: "Pagos de ventas",
                        content: (
                            <div>
                                {renderFilterPanel()}

                                {pagosVentasFiltrados.length > 0 && (
                                    <Card titulo="Listado de pagos">
                                        <TablaPagosVentas
                                            datos={pagosVentasFiltrados}
                                            id="tablaVentasFacturas"
                                        />
                                    </Card>
                                )}
                            </div>
                        )
                    },
                    {
                        title: "Pagos de compras",
                        content: (
                            <div>
                                {renderFilterPanel()}
                                {pagosEfectivoC.length > 0 && (
                                    <Card titulo="Listado de pagos - Efectivo">
                                        <TablaPagosCompras
                                            datos={pagosEfectivoC}
                                            id="tablaComprasFacturas"
                                        />
                                    </Card>
                                )}
                            </div>
                        )
                    },
                ]}
            />
        </Page>
    );
};

export default HomePagos;